export default {
  created() {
  },
  data() {
    return {
      submitLoading: false,
      currentFormLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 18 },
        offsetCol: { span: 18, offset: 5 }
      },
      currentDialogLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      currentFormLayout2: {
        labelCol: { span: 4 },
        wrapperCol: { span: 19 },
        offsetCol: { span: 19, offset: 4 }
      },
      formItemLayout: {
        labelCol: {
          xxl: { span: 6 },
          xl: { span: 7 },
          lg: { span: 8 },
          sm: { span: 9 },
          md: { span: 10 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 18 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 17 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 16 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 15 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 14 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ChaoMaiProductSync', title: '商品同步' },
      { name: 'ChaoMaiOrderList', title: '订单直连' },
      { name: 'ChaoMaiStores', title: '关联账号' }
    ])
  },
  methods: {}
}